'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _createClass = require('@babel/runtime/helpers/createClass');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var MelidataTrackerService = /*#__PURE__*/function () {
  function MelidataTrackerService() {
    _classCallCheck__default["default"](this, MelidataTrackerService);
  }
  return _createClass__default["default"](MelidataTrackerService, [{
    key: "isMelidataEnabled",
    value: function isMelidataEnabled() {
      return typeof melidata === 'function';
    }
  }, {
    key: "sendTrack",
    value: function sendTrack(track) {
      var path = track.path,
        data = track.data,
        type = track.type;
      var eventType = type || 'event';
      melidata('cleanAndSend', eventType, {
        path: path,
        data: data
      });
    }
  }], [{
    key: "notify",
    value: function notify(track) {
      var service = new MelidataTrackerService();
      if (service.isMelidataEnabled()) {
        service.sendTrack(track);
      }
    }
  }, {
    key: "notifyEventually",
    value: function notifyEventually(track) {
      MelidataTrackerService.notify(track);
    }
  }]);
}();
exports.MelidataTrackerService = MelidataTrackerService;
exports["default"] = MelidataTrackerService;
